import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from '../../../utils/animationHelper';
import {
  BUSINESS_TOGGLES,
  getBusinessToggle,
} from '../../../utils/toggleHelpers';
import PromoCardGrid from './promoCardGrid';
import PromoCardSlider from './promoCardSlider';
import PromoCardSkeleton from './promoCardContainerSkeleton';

const PromoCardContainer = ({
  columns,
  page,
  groupRowTitle = '',
  restrictContent = true,
}) => {
  const [isReady, setIsReady] = useState(false);
  const cardCount = columns.length;
  const isSliderEnabled = getBusinessToggle(
    BUSINESS_TOGGLES.PROMO_CARDS_SLIDER,
  );
  const isMobileView = isMobile();
  const needsSlider =
    isSliderEnabled && (isMobileView ? cardCount > 1 : cardCount > 3);

  const commonProps = { columns, page, groupRowTitle, restrictContent };

  useEffect(() => {
    setIsReady(true);
  }, []);

  if (!isSliderEnabled) {
    return <PromoCardGrid {...commonProps} />;
  }

  if (!isReady) {
    return <PromoCardSkeleton {...commonProps} />;
  }

  return needsSlider ? (
    <PromoCardSlider {...commonProps} />
  ) : (
    <PromoCardGrid {...commonProps} />
  );
};

PromoCardContainer.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  page: PropTypes.object.isRequired,
  groupRowTitle: PropTypes.string,
  restrictContent: PropTypes.bool,
};

export default PromoCardContainer;
